import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetByGuidService } from '../../templates/services/get-by-guid-service.template';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { AppLoginContainerModel } from '../../models/app/app-login-container.model';
import { getHttpHeader } from '../../utils/http-header.factory';


@Injectable({
  providedIn: 'root'
})
export class TenantUserProfileService extends GetByGuidService<AppLoginContainerModel> {
    
  constructor(h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'user-profile', h);
  }

  public get({ api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<AppLoginContainerModel>>{
    return this.http.get<ApiResponseModel<AppLoginContainerModel>>(`${ api_domain_url }${ this.apiUrl }`, getHttpHeader(jwt_secret, tenantCode));
  }

  public put(d: AppLoginContainerModel, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<AppLoginContainerModel>> {
    return this.http.put<ApiResponseModel<AppLoginContainerModel>>(`${ api_domain_url }${ this.apiUrl }`, d, getHttpHeader(jwt_secret, tenantCode));
  }

  public uploadImage(form: FormData, iGuid: string, guid: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<any>{
    if (iGuid !== '') return this.http.put(`${ api_domain_url }${ this.apiUrl }/photo/replace/${ iGuid }`, form, getHttpHeader(jwt_secret, tenantCode));
    return this.http.post(`${ api_domain_url }${ this.apiUrl }/photo/${ guid }`, form, getHttpHeader(jwt_secret, tenantCode));
  }
}
